export enum ContactsRoutePages {
  Root = '',
  ContactBook = 'contact-book',
  SignatoryTypeRoles = 'signatory-type-roles'
}
